import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { RolesList } from '@gtpl/shared-models/gtpl';
import { EmployeeRolesEnum } from '@gtpl/shared-models/common-models';
export class CreateUserDto { 
   @ApiProperty()
  @IsNotEmpty()  id: Number; 
  @ApiProperty()
  @IsNotEmpty()  username: string;
  @ApiProperty()
  @IsNotEmpty()  password: string;
  @ApiProperty()
  @IsNotEmpty()  @IsEmail()  email?: string;
  @ApiProperty({ enum: Object.values(EmployeeRolesEnum) })
  @IsNotEmpty() employeeRole: EmployeeRolesEnum;
  @ApiProperty()
  @IsNotEmpty() employeeId: number;
  @ApiProperty()
  @IsNotEmpty() mobileNumber: string;
  @ApiProperty()
  @IsNotEmpty() unitId: number;
  @ApiProperty()
  @IsNotEmpty() isActive: boolean;
  @ApiProperty()
  createdAt : Date;
  @ApiProperty()
  @IsOptional()
  createdUser : string;
  @ApiProperty()
  versionFlag : number;
}
export class updateUserDto {  
  @ApiProperty()
  @IsNotEmpty()  id: Number;
  @ApiProperty()
  @IsNotEmpty()  username: string;
  @ApiProperty()
  @IsNotEmpty()  password: string;
  @ApiProperty()
  @IsNotEmpty()  @IsEmail()  email?: string;
  @ApiProperty({ enum: Object.values(EmployeeRolesEnum) })
  @IsNotEmpty() employeeRole: EmployeeRolesEnum;
  @ApiProperty()
  @IsNotEmpty() employeeId: number;
  @ApiProperty()
  @ApiProperty()
  @IsNotEmpty() unitId: number;
  @IsNotEmpty() mobileNumber: string;
  @ApiProperty()
  @IsNotEmpty() isActive: boolean;
  @ApiProperty()
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  updatedUser : string;
  @ApiProperty()
  versionFlag : number;
}

export class UpdateUserDto {  
  @ApiProperty()
  @IsNotEmpty()  username: string;
  @ApiProperty() password: string;
  @ApiProperty()
  @IsNotEmpty()  @IsEmail()  email?: string;
  @ApiProperty({ enum: Object.values(EmployeeRolesEnum) })
  @IsNotEmpty() employeeRole: EmployeeRolesEnum;
  @ApiProperty()
  @IsNotEmpty() employeeId: number;
  @ApiProperty()
  @IsNotEmpty() unitId: number;
  @ApiProperty()
  @IsNotEmpty() mobileNumber: string;
  @ApiProperty()
  @IsNotEmpty() isActive: boolean;
  @ApiProperty()
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  updatedUser : string;
  @ApiProperty()
  versionFlag : number;
}
export class UserDto { 
  @ApiProperty()
  @IsNotEmpty()  id: number;
  @ApiProperty()
  @IsNotEmpty()  username: string;
  @ApiProperty()
  @IsNotEmpty()  mobileNumber: string;
  @ApiProperty()
  @IsNotEmpty()  @IsEmail()  email?: string;
  @ApiProperty()
  @IsNotEmpty() employeeRole: EmployeeRolesEnum;
  @ApiProperty()
  @IsNotEmpty() unitId: number;

  versionFlag?: number;
}
export class LoginUserDto { 
  @ApiProperty() 
  @IsNotEmpty()  readonly username: string;
  @ApiProperty()
  @IsNotEmpty()  readonly password: string;
}